// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
/* eslint-disable */
export const VERSION = {
    "dirty": false,
    "hash": "3f982b8",
    "fullHash": "3f982b8c74b1ede1283aa9b13829f819d3aa3a82",
    "branch": "HEAD",
    "tag": null
};
/* tslint:enable */
/* eslint-enable */
